module.exports = __webpack_public_path__ + "static/media/woman (4).f0d46b85.png";